var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.15625 3.03125C4.41797 3.03125 3.84375 3.63281 3.84375 4.34375C3.84375 5.08203 4.41797 5.65625 5.15625 5.65625C5.86719 5.65625 6.46875 5.08203 6.46875 4.34375C6.46875 3.63281 5.86719 3.03125 5.15625 3.03125ZM13.2227 0.625H2.72266C1.76562 0.625 0.972656 1.41797 0.972656 2.375V11.125C0.972656 12.1094 1.76562 12.875 2.72266 12.875H13.2227C14.1797 12.875 14.9727 12.1094 14.9727 11.125V2.375C14.9727 1.41797 14.207 0.625 13.2227 0.625ZM13.6602 10.9609L9.91406 5.875C9.83203 5.73828 9.69531 5.65625 9.53125 5.65625C9.33984 5.65625 9.20312 5.73828 9.09375 5.875L6.19531 9.8125L5.18359 8.55469C5.07422 8.44531 4.9375 8.36328 4.77344 8.36328C4.60938 8.36328 4.47266 8.44531 4.36328 8.55469L2.3125 11.125L2.28516 2.375C2.28516 2.15625 2.50391 1.9375 2.72266 1.9375H13.2227C13.4688 1.9375 13.6602 2.15625 13.6602 2.375V10.9609Z",
    fill: "#01000E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.86dddd2e.svg";
export { ForwardRef as ReactComponent };